import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";


@Component({
    selector: 'mi-recaptcha-error',
    imports: [
    ],
    templateUrl: './recaptcha-error.html',
    styleUrl: './recaptcha-error.scss',
    standalone: true,
    encapsulation: ViewEncapsulation.None,

})
export class RecaptchaErrorComponent implements OnInit {

    subscribtion: Subscription = new Subscription();
    errorText: any;

    constructor(
        private translateService: TranslateService
    ) {

    }


    ngOnInit() {
        this.initText();
    }


    initText() {

        this.subscribtion.add(this.translateService.stream('error').subscribe(translation => {
            this.errorText = translation;
        }));

    }
}